<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<app-header class="header"></app-header>

<app-sidebar></app-sidebar>

<div class="content-wrapper">
  <router-outlet></router-outlet>

  <app-footer class="page-footer"></app-footer>
</div>
